import * as tslib_1 from "tslib";
/* I129 in DS */
// from Phrac T35388
import React from 'react';
import IconWrap from '../IconWrap';
var instances = 0;
var Premium = /** @class */ (function (_super) {
    tslib_1.__extends(Premium, _super);
    function Premium() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.instanceId = instances++;
        return _this;
    }
    Premium.prototype.render = function () {
        var maskId = "dollar" + this.instanceId;
        return (React.createElement(IconWrap, tslib_1.__assign({}, this.props),
            React.createElement("svg", { width: "0", height: "0", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" },
                React.createElement("defs", null,
                    React.createElement("mask", { id: maskId },
                        React.createElement("rect", { x: "0", y: "0", width: "24", height: "24", fill: "#fff" }),
                        React.createElement("path", { d: "M5.442 13.64v-1.293C4.12 12.09 3.218 11.26 3 9.967h2.128c.178.516.614.775 1.242.775.573 0 .969-.272.969-.721 0-.422-.26-.585-.819-.721l-1.35-.313c-1.12-.272-2.02-.871-2.02-2.273 0-1.306.914-2.245 2.292-2.476V3H7.19v1.279c1.241.286 1.95 1.13 2.155 2.272H7.325c-.177-.408-.546-.707-1.16-.707-.559 0-.927.272-.927.68 0 .367.232.544.655.653l1.487.367c1.337.327 2.06 1.075 2.06 2.34 0 1.348-.928 2.219-2.251 2.477v1.279H5.442z", fill: "#000" }))),
                React.createElement("g", { transform: "translate(6 4)", fillRule: "evenodd" },
                    React.createElement("path", { d: "M0 0h9.365L13 3.92V16H0z", mask: "url(#" + maskId + ")" })))));
    };
    return Premium;
}(React.Component));
export { Premium };
export default Premium;
//# sourceMappingURL=Premium.js.map